export function MoneyPage() {
  return (
    <>
      <h1 style={{ fontSize: 32, color: 'var(--primary)', marginBottom: 8 }}>Money</h1>
      <p style={{ color: 'var(--text-muted)', maxWidth: 640, marginBottom: 24 }}>
        Gross 28d, avg per visit, pending payout, outstanding deposits. Transactions
        list — no service names, just sheet # + generic type (deposit / visit / program / refund).
      </p>
      <div style={{ padding: 24, background: 'var(--card)', borderRadius: 14, border: '1px solid var(--line-soft)' }}>
        <p style={{ color: 'var(--text-muted)' }}>Stub — wires to payments table once schema is applied.</p>
      </div>
    </>
  );
}
